import {useCallback, useState} from 'react';

import {useIsMounted} from './use-is-mounted';

export function useSafeState<T>(initialValue: T | (() => T)) {
    const [value, setValue] = useState(initialValue);

    const isMounted = useIsMounted();

    const safeSetValue = useCallback(
        (value: React.SetStateAction<T>) => {
            if (!isMounted.current) return;
            setValue(value);
        },
        [isMounted],
    );

    return [value, safeSetValue] as const;
}
